export const fuelUpLink = 'https://github.com/fuellabs/fuelup';
